(function () {
  if (window.bpdWaitlistFormBound) return;
  window.bpdWaitlistFormBound = true;
  document.addEventListener('submit', async function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('[data-bpd-waitlist-form]')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (form.dataset.submitting === 'true' || !form.reportValidity()) return;
    var button = form.querySelector('[type="submit"]');
    var message = form.querySelector('[data-bpd-waitlist-message]');
    var originalLabel = button.textContent;
    var body = new URLSearchParams(new FormData(form));
    var host = form.closest('hdt-back-instock');
    var selector = form.querySelector('[back-instock-select]');
    var linkedId = host ? host.getAttribute('form') : form.getAttribute('data-product-form-id');
    var linked = linkedId && document.getElementById(linkedId);
    var current = linked && linked.querySelector('[name="id"]');
    body.set('variantId', selector ? selector.value : current ? current.value : body.get('variantId'));    form.dataset.submitting = 'true';
    button.disabled = true;
    button.textContent = 'Submitting…';
    message.hidden = true;
    try {
      var response = await fetch(form.action, {
        method: 'POST',
        headers: {'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8', 'Accept': 'application/json'},
        credentials: 'same-origin',
        body: body.toString()
      });
      var data = await response.json();
      if (!response.ok || !data.ok) throw new Error(data.error || 'We could not save your request. Please try again.');
      message.setAttribute('role', 'status');
      message.textContent = 'Thanks. We’ve added you to the waiting list and will email you when we have an update.';
    } catch (error) {
      message.setAttribute('role', 'alert');
      message.textContent = error.message || 'We could not save your request. Please try again.';
    } finally {
      message.hidden = false;
      button.disabled = false;
      button.textContent = originalLabel;
      delete form.dataset.submitting;
    }
  }, true);
}());
